@if (showProgressBar()) {
<div
  class="fdx-o-grid--max-width fdx-o-grid__row--center fdx-u-mb--10 fdx-u-mt--10"
>
  <div class="fdx-c-progress">
    <div class="fdx-c-progress__indicators" role="list">
      @if (showSzczegolyPrzesylki()) {
      <span
        role="listitem"
        class="fdx-c-progress__indicators__button"
        [ngClass]="{
          'fdx-c-progress__indicators__button--active':
            enableSzczegolyPrzesylki()
        }"
      >
        <span class="fdx-c-progress__indicators__button__text"
          >Szczegóły przesyłki</span
        >
      </span>
      } @if (showOpcjeNadania()) {
      <span
        role="listitem"
        class="fdx-c-progress__indicators__button"
        [ngClass]="{
          'fdx-c-progress__indicators__button--active': enableOpcjeNadania()
        }"
      >
        <span class="fdx-c-progress__indicators__button__text"
          >Opcje nadania</span
        >
      </span>
      } @if (showWalidacjaDanych()) {
      <span
        role="listitem"
        class="fdx-c-progress__indicators__button"
        [ngClass]="{
          'fdx-c-progress__indicators__button--active': enableWalidacjaDanych()
        }"
      >
        <span class="fdx-c-progress__indicators__button__text"
          >Walidacja danych</span
        >
      </span>
      } @if (showPotwierdzenie()) {
      <span
        role="listitem"
        class="fdx-c-progress__indicators__button"
        [ngClass]="{
          'fdx-c-progress__indicators__button--active': enablePotwierdzenie()
        }"
      >
        <span class="fdx-c-progress__indicators__button__text"
          >Potwierdzenie</span
        >
      </span>
      } @if (showSzczegolyNadania()) {
      <span
        role="listitem"
        class="fdx-c-progress__indicators__button"
        [ngClass]="{
          'fdx-c-progress__indicators__button--active': enableSzczegolyNadania()
        }"
      >
        <span class="fdx-c-progress__indicators__button__text"
          >Szczegóły nadania</span
        >
      </span>
      }
    </div>
  </div>
</div>
}
